
  import { isEmpty } from 'lodash';

  import text from '@/common/mixins/text';
  import Tooltip from '@/common/ui/Tooltip.vue';

  import IndicatorsWrapper from '../IndicatorsWrapper.vue';

  export default {
    name: 'RussiaLimitations',
    components: {
      Tooltip,
      IndicatorsWrapper,
    },
    mixins: [text],
    props: {
      unfriendlyCountryInfo: {
        type: Array,
        default: () => [],
      },
    },
    computed: {
      unfriendlyCountryInfoList() {
        if (isEmpty(this.unfriendlyCountryInfo)) {
          return [];
        }
        return [
          {
            id: 12,
            title: 'Общее количество ограничений',
            value: this.unfriendlyCountryInfo?.numberOfRestrictions
              ? this.formatNumber(this.unfriendlyCountryInfo?.numberOfRestrictions, 0)
              : '0',
            measure: false,
          },
          {
            id: 13,
            title: 'Стоимость экспорта под ограничениями',
            value: this.unfriendlyCountryInfo?.exportValueUnderRestrictions
              ? this.formatNumber(this.unfriendlyCountryInfo?.exportValueUnderRestrictions, 1)
              : '0,0',
            measure: true,
          },
          {
            id: 14,
            title: 'Стоимость импорта под ограничениями',
            value: this.unfriendlyCountryInfo?.importValueUnderRestrictions
              ? this.formatNumber(this.unfriendlyCountryInfo?.importValueUnderRestrictions, 1)
              : '0,0',
            measure: true,
          },
        ];
      },

      isEuropeanUnionCountry() {
        return this.unfriendlyCountryInfo?.country?.countryGroupId === 10;
      },
    },
  };
